export const mapRunStepsToUi = (runState, idleSteps = []) => {
  const backendSteps = runState?.steps ?? [];
  if (backendSteps.length > 0) {
    return backendSteps.map((step) => {
      const status = step.status ?? 'idle';
      const percentage =
        status === 'completed' ? 100 : status === 'running' ? 50 : status === 'error' ? 100 : 0;
      const counts = step.counts ?? { total: 0, succeeded: 0, failed: 0 };
      const stepProgress =
        counts.total > 0
          ? Math.round((counts.succeeded / counts.total) * 100)
          : percentage;
      return {
        id: step.id,
        label: step.label,
        description: step.description,
        status,
        percentage: stepProgress,
        message: step.message,
        counts,
      };
    });
  }
  return idleSteps.map((template) => ({
    ...template,
    status: 'idle',
    percentage: 0,
  }));
};
